/**
 * API Configuration
 *
 * Centralized env-aware API + Socket URLs.
 * - If running on localhost, default to local backend (http://localhost:5000)
 * - Else, default to production backend
 * - Always respect REACT_APP_API_URL / REACT_APP_SOCKET_URL if provided
 */

const hostname = window.location.hostname || "";
const isLocal =
  hostname.includes("localhost") ||
  hostname.startsWith("127.") ||
  hostname.startsWith("192.168.");

// Environment variables (if defined by build/runtime)
const REACT_APP_API_URL = process.env.REACT_APP_API_URL;
const REACT_APP_SOCKET_URL = process.env.REACT_APP_SOCKET_URL;

// Defaults
const PROD_API_URL = "https://backend-urbanride.rajeshwarinfotech.com/api";
const PROD_SOCKET_URL = "https://backend-urbanride.rajeshwarinfotech.com";
const DEV_API_URL = "http://localhost:5000/api";
const DEV_SOCKET_URL = "http://localhost:5000";

// Resolve URLs
let API_URL = REACT_APP_API_URL || (isLocal ? DEV_API_URL : PROD_API_URL);
let SOCKET_URL = REACT_APP_SOCKET_URL || (isLocal ? DEV_SOCKET_URL : PROD_SOCKET_URL);

// Sanitize SOCKET_URL: remove accidental ":0" port and ensure origin-only (no trailing slash)
try {
  const parsed = new URL(SOCKET_URL);
  if (parsed.port === "0") parsed.port = ""; // remove port 0 if present
  SOCKET_URL = parsed.origin;
} catch (e) {
  // If URL parsing fails, keep the original value
  console.warn('apiConfig: failed to parse SOCKET_URL for sanitization', e && e.message);
}

// Fallback production API URL (kept for compatibility)
const FALLBACK_API_URL = PROD_API_URL;

export { API_URL, SOCKET_URL, FALLBACK_API_URL };
